import React from 'react'
import BusyModal from '../../modals/busy'
import useExperience from '../../../hooks/use-experience'
import { Col, Row } from 'react-bootstrap'
import useCourseAttendees from './use-course-attendees'
import { find, first, sortBy } from 'lodash'
import useCourseEnrollees from '../../experiences/use-enrollees'
import Modal from '../../modals/wrapper'
import Enrollee from './enrollee'
import Attendee from './attendee'
import { Form } from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import SpinnerButton from '../../common/spinner-button'
import useStudents from '../../../hooks/use-students'
import Details from '../details-modal/details'

const AttendanceModal = ({
    experienceId,
    onClose = () => {}
}) => {
    const searchBox = React.useRef(null)
    const [search, setSearch] = React.useState()
    const { isBusy: experienceBusy, experience } = useExperience(null, experienceId)
    const { enrollees: courseEnrollees, isLoading: isLoadingEnrollees } = useCourseEnrollees({ courseId: experienceId })
    const {
        courseAttendees,
        isLoadingCourseAttendees,
        isSavingCourseAttendees,
        addAttendee,
        removeAttendee,
        saveAttendance
    } = useCourseAttendees({ courseId : experienceId })
    const onSearchChange = React.useCallback((attendee) => {
        addAttendee(attendee)
        if(searchBox?.current?.clear) { 
            searchBox.current.clear()
        }
    }, [searchBox, addAttendee])
    const {
        students,
        isLoading: isSearching
    } = useStudents({
        search
    })

    const mapStudentOption = (s) => ({ id: s.id, label: `${s.lastName}, ${s.firstName}`, ...s})

    if (experienceBusy || isLoadingCourseAttendees || isLoadingEnrollees) {
        return (<BusyModal centered />)
    }

    const sortUsers = (users) => sortBy(users, ['lastName', 'firstName'])
    let enrollees = courseEnrollees.filter(e => !find(courseAttendees, { id: e.id }))
    let dropIns = courseAttendees.filter(e => !find(courseEnrollees, { id: e.id }))
    let attendees = courseAttendees.filter(e => !find(dropIns, { id: e.id }))

    enrollees = sortUsers(enrollees)
    dropIns = sortUsers(dropIns)
    attendees = sortUsers(attendees)

    const renderEnrollee = (enrollee) => (
        <Enrollee
            key={enrollee.id}
            user={enrollee}
            onClick={() => addAttendee(enrollee)}
        />
    )

    const renderAttendee = (attendee) => (
        <Attendee
            key={attendee.id}
            user={attendee}
            onClick={() => removeAttendee(attendee)}
        />
    )

    const renderDropin = (attendee) => (
        <Attendee
            key={attendee.id}
            user={attendee}
            onClick={() => removeAttendee(attendee)}
            isDropIn
        />
    )

    return (
        <Modal
            closeButton
            onHide={onClose}
            closeStyle={{ color: 'white' }}
        >
            <Modal.Header>Attendance Management</Modal.Header>

            <div style={{ padding: '20px', paddingTop: '10px' }}>
                <div style={{ textAlign: 'center' }}>{experience.name}</div>
                <Details series={false} description={false} enrollment={false} credits={false} dimensions={false}  experience={experience} />
                <hr/>
                <Row>
                    <Col>
                        <div style={{ textAlign: 'center', textDecoration: 'underline', fontWeight: '900' }}><strong>Absentees</strong></div>
                        {enrollees.map(renderEnrollee)}
                    </Col>
                    <Col>
                        <div style={{ textAlign: 'center', textDecoration: 'underline', fontWeight: '900' }}><strong>Attendees</strong></div>
                        {attendees.map(renderAttendee)}
                        <div style={{ textAlign: 'center', textDecoration: 'underline', fontWeight: '900' }}><strong>Drop-Ins</strong></div>
                        <Form autoComplete='off'>
                            <Form.Group>
                                <AsyncTypeahead
                                    placeholder='Search for students...'
                                    filterBy={() => true}
                                    ref={searchBox}
                                    clearButton
                                    id={'Label'}
                                    onChange={d => onSearchChange(first(d))}
                                    options={students.map(mapStudentOption)}
                                    minLength={3}
                                    onSearch={setSearch}
                                    isLoading={isSearching}
                                />
                            </Form.Group>
                        </Form>
                        {dropIns.map(renderDropin)}
                    </Col>
                </Row>
                <hr />
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                    <SpinnerButton
                        busy={isSavingCourseAttendees}
                        disabled={isSavingCourseAttendees}
                        onClick={() => saveAttendance()}
                    >
                        Save Attendance
                    </SpinnerButton>
                </div>
            </div>
        </Modal>
    )
}

export default AttendanceModal